import { AutoAwesomeRounded } from '@mui/icons-material';
import Tooltip from '@mui/material/Tooltip';

import { Or2Button, type Or2ButtonProps } from '@/components/button/Or2Button';

import { useTrackIntercomEvent } from '@/hooks/useTrackIntercomEvent';

import { useHasGovernorHubKnowledge } from '@/hooks/useHasGovernorHubKnowledge';

import { useAssistant } from '../context/AssistantContext';

import { AssistantDialog } from './assistant-button/AssistantDialog';

export const LaunchAssistantButton = ({ ...other }: Or2ButtonProps) => {
  const { loading, hasGovernorHubKnowledge } = useHasGovernorHubKnowledge();

  const { isOpen, openAssistant, closeAssistant } = useAssistant();

  const trackIntercomEvent = useTrackIntercomEvent();

  return (
    <>
      <Tooltip
        title={
          !hasGovernorHubKnowledge && !loading
            ? 'You need to have GovernorHub Knowledge to use AI Assistant'
            : undefined
        }
      >
        <span>
          <Or2Button
            {...other}
            size="small"
            loading={loading}
            disabled={!hasGovernorHubKnowledge}
            data-tour-id="ai-assistant-button"
            startIcon={<AutoAwesomeRounded />}
            onClick={() => {
              if (!hasGovernorHubKnowledge) {
                return;
              }

              openAssistant();
              trackIntercomEvent(`Clicked AI Assistant Open Dialog Button`);
            }}
          >
            AI Assistant
          </Or2Button>
        </span>
      </Tooltip>
      {hasGovernorHubKnowledge && (
        <AssistantDialog open={isOpen} onClose={closeAssistant} />
      )}
    </>
  );
};
